module.exports = __webpack_public_path__ + "img/pic2.ff1854f0.jpg";